import logo from './logo.svg';
import './App.css';
import MedWellLandingPage from './MedWellLandingPage.tsx';
import { Routes, Route } from "react-router-dom"

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<MedWellLandingPage />} />
      </Routes>
    </>
  );
}

export default App;
